import React from "react";
import { objectTypes } from "../../../core/components/buttonpanel/interface/Ibuttons";


interface IframeworkSoundActiveScreen {
    data: {}

}

export const frameworkSoundActiveScreen: IframeworkSoundActiveScreen = {

    data: {
        "COMPONENTS": [
            {
                "name": "backgroundGraphic",
                "type": "Graphic",
                "shape": "rectangle",
                "visible": true,
                "alpha": 1,
                "color": "0x000000",
                "x": 0,
                "y": 0,
                "width": 1920,
                "height": 1080,

            },

            {
                "name": "backgroundGraphic_portrait",
                "type": "Graphic",
                "shape": "rectangle",
                "visible": true,
                "layout": true,
                "uimode": "mobile",
                "alpha": 1,
                "color": "0x000000",
                "x": 0,
                "y": 0,
                "width": 1080,
                "height": 1920,

            },


            {
                "id": "assetsContainerOfSoundWithoutBg",
                "name": "assetsContainerOfSoundWithoutBg",
                "type": "Container",
                "class": "",
                "x": 0,
                "y": 0,
                "visible": true,
                "filterTypes": [],
                "parentLayer": "baseLayer",
                child: [
                    {
                        "id": "activeSoundText",
                        "name": "activeSoundText",
                        "type": "Text",
                        "x": 847,
                        "y": 440,
                        "width": 300,
                        "visible": true,
                        "text": "preloader_sound",
                        "scaleToFit": true,
                        "anchor": [0, 0],
                        "textStyle": {
                            fontFamily: 'Arial',
                            fontSize: 32,
                            fontStyle: 'normal',
                            fill: ['#FFFFFF'],
                        },
                    },


                    {
                        "id": "Button_soundOn",
                        "name": "Button_soundOn",
                        "type": objectTypes.Sprite,
                        "buttonMode": true,
                        //"uimode": "desktop",
                        "interactive": true,
                        //"layout": true,
                        "x": 486,
                        "y": 516,
                        "width": 360,
                        "height": 150,
                        "text": "",
                        "visible": true,
                        "buttonState": {
                            up: 'no_up.png',
                            out: 'no_up.png',
                            down: 'no_over.png',
                            disable: 'no_up.png',
                            enable: 'no_up.png',
                            hover: 'no_over.png'
                        },
                        "hitareaVisible": true,

                    },
                    {
                        "id": "Button_soundOff",
                        "name": "Button_soundOff",
                        "type": objectTypes.Sprite,
                        "buttonMode": true,
                        // "uimode": "desktop",
                        "interactive": true,
                        //"layout": true,
                        "x": 1048,
                        "y": 516,
                        "width": 360,
                        "height": 150,
                        "text": "",
                        "visible": true,
                        "buttonState": {
                            up: 'no_up.png',
                            out: 'no_up.png',
                            down: 'no_over.png',
                            disable: 'no_up.png',
                            enable: 'no_up.png',
                            hover: 'no_over.png'
                        },
                        "hitareaVisible": true,

                    },

                    {
                        "id": "soundActiveTrueText",
                        "name": "soundActiveTrueText",
                        "type": "Text",
                        "x": 630,
                        "y": 567,
                        "width": 200,
                        "visible": true,
                        "text": "preloader_sound-yes",
                        "scaleToFit": true,
                        "anchor": [0, 0],
                        "textStyle": {
                            fontFamily: 'Arial',
                            fontSize: 32,
                            fontStyle: 'normal',
                            fill: ['#FFFFFF'],
                        },
                    },

                    {
                        "id": "soundActivefalseText",
                        "name": "soundActivefalseText",
                        "type": "Text",
                        "x": 1205,
                        "y": 567,
                        "width": 200,
                        "visible": true,
                        "text": "preloader_sound-no",
                        "scaleToFit": true,
                        "anchor": [0, 0],
                        "textStyle": {
                            fontFamily: 'Arial',
                            fontSize: 32,
                            fontStyle: 'normal',
                            fill: ['#FFFFFF'],
                        },
                    },
                ]
            },



            {
                "id": "assetsContainerOfSoundWithoutBg_portrait",
                "name": "assetsContainerOfSoundWithoutBg_portrait",
                "type": "Container",
                "class": "",
                "x": 0,
                "y": 0,
                "visible": false,
                "filterTypes": [],
                "parentLayer": "baseLayer",
                child: [
                    {
                        "id": "activeSoundText",
                        "name": "activeSoundText",
                        "type": "Text",
                        "x": 828,
                        "y": 530,
                        "width": 380,
                        "visible": true,
                        "text": "preloader_sound",
                        "scaleToFit": true,
                        "anchor": [0, 0],
                        "textStyle": {
                            fontFamily: 'Arial',
                            fontSize: 38,
                            fontStyle: 'normal',
                            fill: ['#FFFFFF'],
                        },
                    },


                    {
                        "id": "Button_soundOn",
                        "name": "Button_soundOn",
                        "type": objectTypes.Sprite,
                        "buttonMode": true,
                        //"uimode": "desktop",
                        "interactive": true,
                        //"layout": true,
                        "x": 770,
                        "y": 645,
                        "width": 360,
                        "height": 150,
                        "text": "",
                        "visible": true,
                        "buttonState": {
                            up: 'no_up.png',
                            out: 'no_up.png',
                            down: 'no_over.png',
                            disable: 'no_up.png',
                            enable: 'no_up.png',
                            hover: 'no_over.png'
                        },
                        "hitareaVisible": true,

                    },
                    {
                        "id": "Button_soundOff",
                        "name": "Button_soundOff",
                        "type": objectTypes.Sprite,
                        "buttonMode": true,
                        // "uimode": "desktop",
                        "interactive": true,
                        //"layout": true,
                        "x": 770,
                        "y": 848,
                        "width": 360,
                        "height": 150,
                        "text": "",
                        "visible": true,
                        "buttonState": {
                            up: 'no_up.png',
                            out: 'no_up.png',
                            down: 'no_over.png',
                            disable: 'no_up.png',
                            enable: 'no_up.png',
                            hover: 'no_over.png'
                        },
                        "hitareaVisible": true,

                    },

                    {
                        "id": "soundActiveTrueText",
                        "name": "soundActiveTrueText",
                        "type": "Text",
                        "x": 914,
                        "y": 695,
                        "width": 280,
                        "visible": true,
                        "text": "preloader_sound-yes",
                        "scaleToFit": true,
                        "anchor": [0, 0],
                        "textStyle": {
                            fontFamily: 'Arial',
                            fontSize: 38,
                            fontStyle: 'normal',
                            fill: ['#FFFFFF'],
                        },
                    },

                    {
                        "id": "soundActivefalseText",
                        "name": "soundActivefalseText",
                        "type": "Text",
                        "x": 920,
                        "y": 891,
                        "width": 280,
                        "visible": true,
                        "text": "preloader_sound-no",
                        "scaleToFit": true,
                        "anchor": [0, 0],
                        "textStyle": {
                            fontFamily: 'Arial',
                            fontSize: 38,
                            fontStyle: 'normal',
                            fill: ['#FFFFFF'],
                        },
                    },
                ]
            },


            {
                "id": "freespinBrokenPopup_container",
                "name": "freespinBrokenPopup_container",
                "type": "Container",
                "x": 0,
                "y": 0,
                "visible": false,
                "layout": true,
                child: [
                    
                    {
                        "name": "freespinBrokenPopup",
                        "type": "Graphic",
                        "shape": "rectangle",
                        "visible": true,
                        "interactive": true,
                        "buttonMode": true,
                        "anchor": [0.5, 0.5],
                        "alpha": 1,
                        "color": "0x26580F",
                        "x": 404,
                        "y": 280,
                        "width": 1175,
                        "height": 400,
                    },

                    {
                        "id": "popUpFGBrokenText2",
                        "name": "popUpFGBrokenText2",
                        "type": "Text",
                        "x": 980,
                        "y": 470,
                        "width": 800,
                        "visible": true,
                        "text": "ui-popup_play-fs",
                        "scaleToFit": true,
                        "anchor": [0.5, 0.5],
                        "textStyle": {
                            fontFamily: 'Arial',
                            fontSize: 80,
                            fontStyle: 'normal',
                            fill: ['#FFFFFF'],
                        },
                    },

                ]
            },


        ],
    }
};

export const SoundActiveScreenConfigurationContext = React.createContext(
    {}
);